<template>
    <div class="sustainable-component admin-department">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa avdelning" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="DepartmentName"
                                                      id="DepartmentName"
                                                      type="text"
                                                      label="Avdelningsnamn"
                                                      variant="outlined"
                                                      v-model="department.DepartmentName"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="Adress"
                                                      id="Adress"
                                                      type="text"
                                                      label="Adress"
                                                      variant="outlined"
                                                      v-model="department.Address"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="ZipCode"
                                                      id="ZipCode"
                                                      type="text"
                                                      label="Postnummer"
                                                      variant="outlined"
                                                      v-model="department.ZipCode"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="City"
                                                      id="City"
                                                      type="text"
                                                      label="Ort"
                                                      variant="outlined"
                                                      v-model="department.City"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="Telephone"
                                                      id="Telephone"
                                                      type="text"
                                                      label="Telefon"
                                                      variant="outlined"
                                                      v-model="department.Telephone"></v-text-field>
                                        <div class="company-create-actions">
                                            <v-btn variant="tonal" @click="createDepartment" class="bg-primary">
                                                Skapa
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{filteredDepartments.length}} av {{departments.length}} avdelningar</b>
                <div class="mt-3">
                    <v-text-field bg-color="white"
                                  name="FilterDepartment"
                                  id="FilterDepartment"
                                  type="text"
                                  label="Filtrera på avdelning, avdelningsnummer, adress, postnummer, ort eller telefon"
                                  variant="outlined"
                                  v-model="filter"
                                  focused="true"></v-text-field>
                </div>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Avdelning</th>
                            <th class="col-2">AvdelningNr</th>
                            <th class="col-2">Adress</th>
                            <th class="col-2">Postnr</th>
                            <th class="col-2">Ort</th>
                            <th class="col-2">Telefon</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filteredDepartments" :key="index">
                            <td>{{item.DepartmentName}}</td>
                            <td>{{item.DepartmentNumber}}</td>
                            <td>{{item.Address}}</td>
                            <td>{{item.ZipCode}}</td>
                            <td>{{item.City}}</td>
                            <td>{{item.Telephone}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateDepartment(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteDepartment(item.DepartmentId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateDepartment ref="updateDepartmentModal" @updated="loadDepartments"></UpdateDepartment>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateDepartment from './update/update-department.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateDepartmentModal = ref(null);

    export default {

        name: 'admin-department',
        props: {

        },
        components: {
            UpdateDepartment,
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async createDepartment() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await AdminService.createDepartment(this.department);
                    this.displaySnackBar("Avdelningen lades till");
                    this.loadDepartments();
                }
                catch (error) {
                    this.displayErrorSnackBar(this.getErrorMessage(error))
                }
                this.loading--;
            },
            async loadDepartments() {
                this.loading++;
                try {
                    this.departments = await AdminService.getDepartments();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateDepartment(department) {
                this.loading++;
                this.updateDepartmentModal.open(department)
                this.loading--;
            },
            async deleteDepartment(departmentId) {
                if (confirm("Är du säker att du vill radera avdelningen?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteDepartment(departmentId);
                        this.displaySnackBar("Avdelningen togs bort");
                        this.loadDepartments();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            getErrorMessage(error) {
                if (error && error.data && Array.isArray(error.data) && error.data.length > 0) {
                    return error.data[0];
                }
                if (error && error.response && error.response.data && Array.isArray(error.response.data) && error.response.data.length > 0) {
                    return error.response.data[0];
                }

                return "Ett oväntat fel har inträffat";
            },
            matchesFilter(department) {
                const filter = (this.filter || "").trim().toLowerCase();
                if (filter.length === 0) {
                    return true;
                }

                const searchableText = [
                    department.DepartmentName,
                    department.DepartmentNumber,
                    department.Address,
                    department.ZipCode,
                    department.City,
                    department.Telephone
                ].join(" ").toLowerCase();

                return filter
                    .split(/\s+/)
                    .every(term => searchableText.indexOf(term) >= 0);
            },
        },

        computed: {
            filteredDepartments() {
                return this.departments.filter(this.matchesFilter);
            }
        },

        data() {
            return {
                rules: ValidationService.rules(),
                department: {
                    DepartmentName: '',
                    Address: '',
                    ZipCode: '',
                    City: '',
                    Telephone: ''
                },
                departments: [],
                filter: '',
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.filter = new URLSearchParams(window.location.search).get('filter') || '';
            this.loadDepartments();
        },
        setup() {
            return { form, updateDepartmentModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>